import { render, staticRenderFns } from "./Headline.component.vue?vue&type=template&id=2be40164&scoped=true"
import script from "./Headline.component.vue?vue&type=script&lang=js"
export * from "./Headline.component.vue?vue&type=script&lang=js"
import style0 from "./Headline.component.vue?vue&type=style&index=0&id=2be40164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be40164",
  null
  
)

export default component.exports